/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core'
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop'
import { NavigationEnd, Router } from '@angular/router'
import { filter, map } from 'rxjs'
import { FooterHeightService } from './services/footer-height/footer-height.service'
import { MetaFieldsService } from './services/meta-fields/meta-fields.service'
import { getMetaTitleKeysFromRouterRootSnapshot } from './services/meta-fields/meta-fields.route-utils'

const TOAST_BOTTOM_PADDING = 16

@Component({
  selector: 'myprofile-signup-ui-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  private footerHeightService = inject(FooterHeightService)
  private router = inject(Router)
  private metaFieldsService = inject(MetaFieldsService)
  private destroyRef = inject(DestroyRef)

  // Toast should always be above the Footer for better readability - therefore we calculate the bottom position based on the Footer height
  toastStyle = toSignal(
    this.footerHeightService.height$.pipe(map((height) => ({ '--p-toast-position-bottom': `${height + TOAST_BOTTOM_PADDING}px` }))),
    { initialValue: { '--p-toast-position-bottom': `${TOAST_BOTTOM_PADDING}px` } },
  )

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        const titleKeys = getMetaTitleKeysFromRouterRootSnapshot(this.router.routerState.snapshot.root)
        if (titleKeys) {
          this.metaFieldsService.updateTitle(titleKeys)
        }
      })
  }
}
